/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {Redirect} from 'react-router';
import { Trans } from 'react-i18next';

import Button from './Button'

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {createTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';

import i18n from '../resources/i18n';
import { properties } from '../resources/properties.js';

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class Pie extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAlertModal: false,
      showAlertModalError: false,
      showAlertModalHojas: false
    };
  }

  setStateGlobal = (value) => (event) => {
    let {parentState} = this.props;
    const {setParentStateSteps} = this.props;
    const active = parseInt(parentState.active, 10);
    parentState.active = active;
    if (value === 'remove') {
      if (parentState.active === 0 || parentState.active === 3 || parentState.active === 4 || parentState.active === 6 || parentState.active === 8 || parentState.active === 10 || parentState.active === 13) {
        this.handleOnClick();
      } else {
        parentState.active -= 1;
      }

    } else if (value === 'add') {
      if ((parentState.active === 1 || parentState.active === 4) && (!document.getElementById('textAuthor').validity.valid || !document.getElementById('titleStep2').validity.valid || (parentState.specialMapGeneration && (!document.getElementById('imagenCodigoBarras').validity.valid || !document.getElementById('textDepositoLegal').validity.valid || !document.getElementById('textISBN').validity.valid || !document.getElementById('textNipo').validity.valid)))) {
        this.checkValidity(parentState.specialMapGeneration);
        this.setState({showAlertModal: true});
      } else if ((parentState.active === 10) && (window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').getCountHojas() < 2)) {
        this.setState({showAlertModalHojas: true});
      } else if (parentState.active === 11 && (parentState.serImgC && parentState.serImgC.find(e=>!(e.title && e.title.length) || !(e.author && e.author.length) || (parentState.specialMapGeneration && (!(e.nipo && e.nipo.length) || !(e.isbn && e.isbn.length) || !(e.depositoLegal && e.depositoLegal.length) || !(e.codigoBarras && e.codigoBarras.length))) ))){
        parentState.setSelectedHojaEdit(parentState.serImgC.findIndex(e=>!(e.title && e.title.length) || !(e.author && e.author.length) || (parentState.specialMapGeneration && (!(e.nipo && e.nipo.length) || !(e.isbn && e.isbn.length) || !(e.depositoLegal && e.depositoLegal.length) || !(e.codigoBarras && e.codigoBarras.length))) ));
        this.checkValidity(parentState.specialMapGeneration);
        this.setState({showAlertModal: true});
      } else if (this.props.parentState.estado === 0) {
        this.setState({showAlertModalError: true});
      } else if (this.props.parentState.estado !== 0) {
        parentState.active += 1;
      }
      //if (parentState.active === 14 && (!document.getElementById('textAuthor').validity.valid || !document.getElementById('titleStep2').validity.valid || !document.getElementById('imagenCodigoBarras').validity.valid || !document.getElementById('textDepositoLegal').validity.valid || !document.getElementById('textISBN').validity.valid || !document.getElementById('textNipo').validity.valid)){this.checkValidity(parentState.specialMapGeneration);this.setState({showAlertModal: true});} else
    }

    setParentStateSteps(parentState);
  }
  checkValidity(specialMapGeneration){
    if (!document.getElementById('textAuthor').validity.valid) {
      document.getElementById('textAuthor').style.borderBottomColor = '#ff0000';
    } else {
      document.getElementById('textAuthor').style.borderBottomColor = 'black';
    }
    if (!document.getElementById('titleStep2').validity.valid) {
      document.getElementById('titleStep2').style.borderBottomColor = '#ff0000';
    } else {
      document.getElementById('titleStep2').style.borderBottomColor = 'black';
    }
    if(specialMapGeneration){
      if (!document.getElementById('imagenCodigoBarras').validity.valid) {
        document.getElementById('imagenCodigoBarras').style.borderBottomColor = '#ff0000';
      } else {
        document.getElementById('imagenCodigoBarras').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textDepositoLegal').validity.valid) {
        document.getElementById('textDepositoLegal').style.borderBottomColor = '#ff0000';
      } else {
        document.getElementById('textDepositoLegal').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textISBN').validity.valid) {
        document.getElementById('textISBN').style.borderBottomColor = '#ff0000';
      } else {
        document.getElementById('textISBN').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textNipo').validity.valid) {
        document.getElementById('textNipo').style.borderBottomColor = '#ff0000';
      } else {
        document.getElementById('textNipo').style.borderBottomColor = 'black';
      }
    }
  }

  handleCloseWizardError = () => {
    this.setState({showAlertModalError: false});
  }
  handleCloseWizard = () => {
    this.setState({showAlertModal: false});
  }
  handleCloseWizardHojas = () => {
    this.setState({showAlertModalHojas: false});
  }

  handleOnClick = () => {
    this.setState({redirect: true});
  }

  setStateGlobal2 = (event) => {
    let {parentState} = this.props;
    const {setParentStateSteps} = this.props;
    parentState.active = 0;
    setParentStateSteps(parentState);
  }

  render() {
    const {buttonType, parentState, isStep3} = this.props;
    const buttonTextClassNameRight = isStep3 === 0
      ? 'mc-arrow-right'
      : 'mc-add';
    const buttonTextClassNameLeft = 'mc-arrow-left';
    const buttonclassName = 'active';

    if (this.state.redirect) {
      return <Redirect to=""/>;
    }

    let traduccionInputs = i18n.t('dialog.textFormError1') || 'Para completar el mapa debe introducir el título y el autor/a.';
    if(parentState){
      if(parentState.specialMapGeneration){
        if(parentState.active === 11){//Series Especial
          traduccionInputs = i18n.t('dialog.textFormError1SerieEspecial') || 'Para completar la serie especial, debe introducir el título, autor/a, NIPO, ISBN, Depósito Legal y código de barras en todas las hojas.';
        } else {//Especial
          traduccionInputs = i18n.t('dialog.textFormError1Especial') || 'Para completar mapa especial, debe introducir el título, autor/a, NIPO, ISBN, Depósito Legal y código de barras.';
        }
      } else if(parentState.active === 11){//Series
        traduccionInputs = i18n.t('dialog.textFormError1Serie') || 'Para completar la serie, debe introducir el título y autor/a en todas las hojas.';
      }
    }

    return ([
      <footer key='footer1' className="footerButtons" style={this.props.tieneFlecha === "true"
          ? {
            "display": "none"
          }
          : {}}>
        <div className="boton-add">
          <Button value='remove' name={parentState} buttonTextclassName={buttonTextClassNameLeft} onClick={this.setStateGlobal('remove')}/>
        </div>
        <div className="f-separator"></div>
        <div className="boton-add">
          <Button name={parentState} value='add' isStep3={isStep3} buttonType={buttonType} buttonTextclassName={buttonTextClassNameRight} buttonClass={buttonclassName} onClick={isStep3 === 0
              ? this.setStateGlobal('add')
              : this.setStateGlobal2}/>
        </div>
        <a href="#" className="toggle-footer-btn">
          <i className="arrow up"></i>
        </a>
      </footer>,
      <footer key='footer2'>
        <div className="footer">
          <div className="col-7 col-m-12">
            <div className="col-6 col-m-12">
              <ul className="footer">
                <li style={{
                    "fontSize" : "18px",
                    "color" : "rgba(241,131,46,1)",
                    "lineSize" : "200%"
                  }}>
                  <span>
                    <Trans i18nKey="foot.clientInformation">
                      Información al cliente
                    </Trans>
                  </span>
                </li>
                <li>
                  <a href="https://centrodedescargas.cnig.es/CentroDescargas/catalogo" target="_blank" rel="noopener noreferrer">
                    <Trans i18nKey="foot.productCatalog">
                      Catálogo de productos
                    </Trans>
                  </a>
                </li>
                <li>
                  <a href="https://www.cnig.es/condicionesCompra">
                    <Trans i18nKey="foot.purchaseConditions">
                      Condiciones de compra
                    </Trans>
                  </a>
                </li>
                <li>
                  <a href="https://www.cnig.es/puntosVenta"><Trans i18nKey="foot.pointsOfSale">Puntos de venta</Trans></a>
                </li>
                <li>
                  <a href="https://www.cnig.es/contactar"><Trans i18nKey="foot.contactUs">Contactar</Trans></a>
                </li>

              </ul>
            </div>
            <div className="col-6 col-m-12">
              <ul className="footer FooterDecoration1">
                <li style={{
                    "fontSize" : "18px",
                    "color" : "rgba(241,131,46,1)",
                    "lineSize" : "200%"
                  }}>
                  <span><Trans i18nKey="foot.otherInformation">Otra información</Trans></span>
                </li>
                <li>
                  <a href="https://www.cnig.es/faqs"><Trans i18nKey="foot.FAQ">Preguntas frecuentes</Trans></a>
                </li>
                <li>
                  <a href="https://www.cnig.es/mapaWeb"><Trans i18nKey="foot.mapaWeb">Mapa web</Trans></a>
                </li>
                <li>
                  <a href="https://www.cnig.es/quienesSomos"><Trans i18nKey="foot.aboutUs">Acerca de nosotros</Trans></a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-5 col-m-12">
            <ul className="listaFooterRight floatRight">
              <li style={{
                  "fontSize" : "18px",
                  "color" : "rgba(241,131,46,1)",
                  "lineSize" : "200%"
                }}>
                <span><Trans i18nKey="foot.politics">Políticas</Trans></span>
              </li>
              <li className='TemporalLI'></li>
              <li>
                <a href="https://www.cnig.es/seguridad"><Trans i18nKey="foot.security">Seguridad</Trans></a>
              </li>
              <li>
                <a href="https://www.cnig.es/informacionLegal"><Trans i18nKey="foot.legalWarning">Aviso legal</Trans></a>
              </li>
              <li>
                <a href="https://www.cnig.es/propiedadIntelectual"><Trans i18nKey="foot.intelectualProperty">Propiedad intelectual</Trans></a>
              </li>
              <li>
                <a href="https://www.cnig.es/cookiesPublicidad"><Trans i18nKey="foot.cookies">Información de cookies</Trans></a>
              </li>
              <li>
                <a href="https://www.cnig.es/proteccionDatos"><Trans i18nKey="foot.privacy">Privacidad y protección de datos</Trans></a>
              </li>
            </ul>
          </div>
          <p id="social2">
            © Centro Nacional de Información Geográfica (CNIG) NIF.: ES Q2817024I C/ General Ibáñez de Ibero, 3. 28003 - Madrid - España.</p>

        </div>

        <Dialog open={this.state.showAlertModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {traduccionInputs}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizard}>
                <Trans i18nKey="dialog.accept">
                  Aceptar
                </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.showAlertModalError} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="dialog.noGeographicInformation">
                El área seleccionada no contiene información geográfica. Por favor seleccione un área correspondiente a España (Península, Canarias y Baleares).
              </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizardError}>
                <Trans i18nKey="dialog.accept">
                  Aceptar
                </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.showAlertModalHojas} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="dialog.minSheet">
                Tiene que haber como mínimo 2 hojas para seguir adelante.
              </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizardHojas}>
                <Trans i18nKey="dialog.accept">
                  Aceptar
                </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        </footer>]);
  }
}

export default Pie;
